import React from 'react'
 import useSEO from "./useSEO";

const Manpowermanagement = () => {

  useSEO({ 
  title: "Manpower Management Services | Skilled Workforce Solutions in Hyderabad",
  description: "Optimize your business operations with our professional manpower management services in Hyderabad. We provide skilled staffing solutions, workforce planning, and HR support to meet your organizational needs effectively.",
  keywords: "manpower management services, workforce management Hyderabad, staffing solutions, employee management services, contract staffing, HR outsourcing, talent acquisition, manpower outsourcing company",
  ogTitle: "Manpower Management Services - Trusted Hyderabad Experts",
  ogDescription: "Reliable manpower management and staffing solutions to help businesses in Hyderabad grow and succeed.",
  ogImage: "img/manpower-management.png",
  twitterTitle: "Manpower Management Services - Trusted Hyderabad Experts",
  twitterDescription: "Get skilled manpower, workforce planning, and HR support with our expert manpower management services in Hyderabad.",
  twitterImage: "img/manpower-management.png"
});
  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Manpower Management Services </h1>
          <p className="mb-4">
            {" "}
            Efficient manpower management is critical to driving productivity,
            optimizing costs, and maintaining smooth operations. Our Manpower
            Management Services are designed to help businesses recruit, deploy,
            and manage their workforce effectively—whether for short-term
            projects or long-term growth.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/manpower-management.png" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/manpower-management1.png"
              className="rounded"
              alt=""
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4">Our Key Offerings:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Skilled &amp; Unskilled Workforce Supply</b>
                </li>
                <p>
                  We provide reliable and trained manpower for diverse
                  industries including Construction, Real Estate, Manufacturing,
                  Retail, and more.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Contract Staffing &amp; On-Demand Deployment </b>
                </li>
                <p>
                  Whether you need staff for a day, a season, or a project—we
                  offer flexible workforce solutions tailored to your business
                  needs.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Recruitment &amp; Screening</b>
                </li>
                <p>
                  Our expert HR team handles candidate sourcing, background
                  checks, and onboarding to ensure quality hiring and minimal
                  turnaround time.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Attendance &amp; Shift Management </b>
                </li>
                <p>
                  {" "}
                  Track workforce attendance, working hours, and shift rotations
                  using efficient systems to ensure accuracy and reduce payroll
                  errors.{" "}
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Compliance &amp; Labour Law Adherence</b>
                </li>
                <p>
                  {" "}
                  We take full responsibility for ensuring compliance with all
                  labor laws, PF, ESI, and other statutory obligations.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Performance Monitoring &amp; Reporting</b>
                </li>
                <p>
                  Monitor staff productivity, generate reports, and make
                  data-driven decisions for better workforce utilization.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default Manpowermanagement
